const gapDataELA = [
  {
    District: 'L.A. County Office of Education',
    'Difference in performance': 65.88,
    'White students': 77.78,
    'Black students': 11.9,
  },
  {
    District: 'San Francisco Unified',
    'Difference in performance': 57.04,
    'White students': 75,
    'Black students': 17.96,
  },
  {
    District: 'Oakland Unified',
    'Difference in performance': 53.95,
    'White students': 73.76,
    'Black students': 19.81,
  },
  {
    District: 'Sequoia Union High',
    'Difference in performance': 53.86,
    'White students': 87.20,
    'Black students': 33.34,
  },
  {
    District: 'Berkeley Unified',
    'Difference in performance': 53.04,
    'White students': 83.04,
    'Black students': 30,
  },
];

export default gapDataELA;
